import React from "react";
import Blueline from "../../assets/blueline.svg";
import Boy from "../../assets/boy.png";
import DownloadCv from "../../assets/download-cv.svg";
import { useMediaQuery } from "@mui/material";
import "./home.css";

const Home = () => {
  const isNonMobileScreen = useMediaQuery("(min-width: 1000px)");
  return (
    <div className="n-intro">
      <div className="n-intro-left">
        <div className="n-name">
          <p className="name">
            I'm<br></br>Abhyudaya
            <span className="blue-text"> Kandwal</span>
          </p>
        </div>
        <img className="b-line" src={Blueline} alt="line" />
        <div className="n-intro">
          I am a full stack web developer and android developer with a passion
          for creating innovative and user-friendly digital experiences. With
          experience in both front-end and back-end development, I am
          well-versed in a variety of programming languages and technologies.
        </div>
        <div className="btns">
          <img className="n-download-cv" src={DownloadCv} alt="download-cv" />

          <div
            className="hire-me-btn"
            onClick={() =>
              (window.location.href = "mailto:abhyudayakandwal001@gmail.com")
            }
          >
            Hire Me
          </div>
        </div>
      </div>

      {isNonMobileScreen && (
        <div className="n-intro-right">
          <img className="boy" src={Boy} alt="" />
          <div class="wrapper">
            <span>CPP</span>
            <span>DSA</span>
            <span>HTML</span>
            <span>CSS</span>
            <span>JS</span>
            <span>NODE</span>
            <span>REACT</span>
            <span>MONGO</span>
            <span>ANDROID</span>
            <span>FIGMA</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
